import {SnapshotChipsAllowList} from 'BenchlingConfig';
import getConfig from 'getConfig';

const DISABLE_SNAPSHOT_CHIPS_PARAM = 'disableSnapshotChips';

function isSnapshotChipsDisabledViaParam(): boolean {
  return new URLSearchParams(window.location.search).get(DISABLE_SNAPSHOT_CHIPS_PARAM) === 'true';
}

function getAllowList(): SnapshotChipsAllowList {
  return getConfig('ELN_EXPORT_SNAPSHOT_CHIPS_ALLOW_LIST');
}
export function isInAllowList(snapshotChipType: keyof SnapshotChipsAllowList): boolean {
  if (isSnapshotChipsDisabledViaParam()) {
    return false;
  }
  return getAllowList()[snapshotChipType] ?? false;
}
